import { ESTABLISHMENT_ID, ESTABLISHMENT_REGION_ID } from '@/constants/config';
import { BBookableTypeEnum } from '@/types/backend';
import { FTunnelPageBookingTypeEnum } from '@/types/tunnel';
const getGTMItem = ({ experience, bookingType, nbAdults, bookingLanguage, discountAmount }) => {
    const discount = discountAmount ? discountAmount / (nbAdults ?? 1) : 0;
    const price = experience?.callPrice?.value != null ? Math.max(experience?.callPrice?.value - discount, 0) : 0;
    return {
        item_id: `${experience?.identifier ?? 'unknown_experience'}${bookingType === FTunnelPageBookingTypeEnum.voucher ? '-voucher' : ''}`,
        item_name: `${bookingType === FTunnelPageBookingTypeEnum.voucher ? 'Gift Voucher - ' : ''}${experience?.name ?? 'unknown_experience'}`,
        affiliation: `${ESTABLISHMENT_ID}`,
        // establishmentID
        item_brand: `${ESTABLISHMENT_ID}`,
        // establishmentID
        item_category: `${ESTABLISHMENT_REGION_ID}`,
        //regionId
        item_category2: experience?.type ?? 'unknown_experience',
        item_category3: experience?.typeActivity?.identifier ? `${experience.typeActivity.identifier}-${experience.typeActivity.name}` : 'unknown_experience',
        item_variant: experience?.type === BBookableTypeEnum.Activity ? bookingLanguage : null,
        price,
        //prix par adulte
        quantity: nbAdults ?? 0,
        // nbAdultes
        discount
    };
};
export default getGTMItem;
